module.exports = __webpack_public_path__ + "compass.svg?c87c973f85015c980eb8efbb95eacad7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/compass.svg
// module id = 833
// module chunks = 0